<template>
    <Modal :id="'Proposta_Crud'" size="" :open="show" :FooterDefault="false" :ClassBG="true">
        <template v-slot:header>
            <h6 class="modal-title" style="margin-left:-10px;">Proposta</h6>
            <button type="button" class="btn" data-bs-dismiss="modal" aria-label="Close" @click="fecharModal()"><i class="fas fa-times btn-close-style-v2 hover-effect"></i></button>
        </template>
        <template v-slot:body>
            <Form ref="ABC" @submit="submitForm">
                <div class="row fundo-panel" :style="customHeight">
                    <div class="col-12">
                        <div class="">
                            <label for="exampleFormControlInput1" class="form-label" style="font-size: 20px">Dados da Proposta</label>
                        </div>
                        <div class="linha-cinza" style="margin-top: -5px"></div>

                        <div class="row">
                            <div class="col">
                                <label for="exampleFormControlInput1" class="form-label">Nome Contato</label>
                                <vue-select :options="pessoa_instituicao" v-model="pessoa_instituicao_selects"
                                            :label-by="formatNamePessoa" placeholder="Selecione o Contato" search-placeholder="Pesquise"
                                            searchable close-on-select clear-on-select :min="1" class="form-control shadow-v2"
                                            :class="{ filled: PropostaElaboracaoCrud.idPessoa > 0 }"
                                            :disabled="PropostaElaboracaoCrud.idEtapaAtual == 6 || PropostaElaboracaoCrud.idEtapaAtual == 2 || PropostaElaboracaoCrud.idEtapaAtual == 5">
                                </vue-select>
                                <ErrorMessage name="nmContatoCliente" class="form-error" v-show="showErrorMessage" />
                            </div>
                            <div class="col">
                                <label for="exampleFormControlInput1" class="form-label">E-mail</label>
                                <Field name="dsEmail" label="E-mail" type="text" class="form-control shadow-v2"
                                       v-model="PropostaElaboracaoCrud.dsEmail" disabled :rules="{ required: true, email: true }" />
                                <ErrorMessage name="dsEmail" class="form-error" v-show="showErrorMessage" />
                            </div>
                        </div>





                        <div class="row mt-3">

                            <div class="col-6">
                                <label for="exampleFormControlInput1" class="form-label">Nº Proposta</label>
                                <Field name="nrProposta" label="Nº Proposta" type="text" class="form-control shadow-v2"
                                       rules="required" v-model="PropostaElaboracaoCrud.nrProposta" disabled />
                                <ErrorMessage name="nrProposta" class="form-error" v-show="showErrorMessage" />
                            </div>
                            <div class="col-6">
                                <label for="exampleFormControlInput1" class="form-label">Ano Proposta</label>
                                <Field name="nrAno" label="Ano Proposta" type="text" class="form-control shadow-v2"
                                       rules="required" v-model="PropostaElaboracaoCrud.nrAno" disabled />
                                <ErrorMessage name="nrAno" class="form-error" v-show="showErrorMessage" />
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col">
                                <label for="exampleFormControlInput1" class="form-label">Data Geração</label>
                                <DateInput name="dtGeracao" v-model="PropostaElaboracaoCrud.dtGeracaoString" class="col-12"
                                           :isRequired="true" :customWidth="customWidthDate" dateFormat="DD/MM/YYYY" disabled />
                                           <!--:disabled="PropostaElaboracaoCrud.idEtapaAtual == 6 || PropostaElaboracaoCrud.idEtapaAtual == 2 || PropostaElaboracaoCrud.idEtapaAtual == 5"-->
                                <ErrorMessage name="dtGeracao" class="form-error" v-show="showErrorMessage" />
                            </div>
                            <div class="col">
                                <label for="exampleFormControlInput1" class="form-label">Data Validade</label>
                                <DateInput name="dtValidade" v-model="PropostaElaboracaoCrud.dtValidadeString"
                                           class="col-12"
                                           :disabled="PropostaElaboracaoCrud.idEtapaAtual == 6 || PropostaElaboracaoCrud.idEtapaAtual == 2 || PropostaElaboracaoCrud.idEtapaAtual == 5"
                                           :isRequired="true" :customWidth="customWidthDate" dateFormat="DD/MM/YYYY" />
                                <ErrorMessage name="dtValidade" class="form-error" v-show="showErrorMessage" />
                            </div>
                        </div>

                        <div class="row mt-3">
                           
                            <div class="col">
                                <label for="idTipoProposta" class="form-label">Tipo Proposta</label>
                                <select name="idTipoProposta" class="form-select shadow-v2 text-muted" v-model="PropostaElaboracaoCrud.idTipoProposta">
                                    <option value="null" selected>Selecione</option>
                                    <option value="1" selected>Presencial</option>
                                    <option value="2" v-if="evento.idTipoEvento > 1">Online</option>
                                </select>
                                <ErrorMessage name="idTipoProposta" class="form-error" v-show="showErrorMessage" />
                            </div>

                            <div class="col">
                                <label for="exampleFormControlInput1" class="form-label">Qtd Participantes</label>
                                <Field name="qtdInscritos" label="Qtd Participantes" type="number" class="form-control shadow-v2"
                                       rules="required"
                                       :disabled="PropostaElaboracaoCrud.idEtapaAtual == 6 || PropostaElaboracaoCrud.idEtapaAtual == 2 || PropostaElaboracaoCrud.idEtapaAtual == 5"
                                       v-model="PropostaElaboracaoCrud.qtdInscritos" />
                                <ErrorMessage name="qtdInscritos" class="form-error" v-show="showErrorMessage" />
                            </div>

                            <div class="col">
                                <label for="exampleFormControlInput1" class="form-label">Valor Proposta</label>
                                <CurrencyInput :id="'vlProposta'" v-bind:value="PropostaElaboracaoCrud.vlProposta"
                                               v-model="PropostaElaboracaoCrud.vlProposta" :options="{ currency: 'BRL', precision: 2 }"
                                               disabled />
                                <ErrorMessage name="vlProposta" class="form-error" v-show="showErrorMessage" />

                            </div>
                        </div>


                        <div class="row mt-3">
                            <div class="col">
                                <label for="exampleFormControlInput1" class="form-label">E-mail Cópia</label>
                                <Field name="dsEmailCopia" label="E-mail Cópia" type="text" class="form-control shadow-v2"
                                       :disabled="PropostaElaboracaoCrud.idEtapaAtual == 6 || PropostaElaboracaoCrud.idEtapaAtual == 2 || PropostaElaboracaoCrud.idEtapaAtual == 5"
                                       v-model="PropostaElaboracaoCrud.dsEmailCopia"
                                       :class="{ filled: PropostaElaboracaoCrud.dsEmailCopia }" />
                                <ErrorMessage name="dsEmailCopia" class="form-error" v-show="showErrorMessage" />
                            </div>
                            <div class="col">

                            </div>
                        </div>


                        <div class="mb-3 mt-3">
                            <label class="form-label">Observação</label>
                            <textarea class="form-control shadow-v2" id="txt_dsObservacao" rows="4"
                                      :disabled="PropostaElaboracaoCrud.idEtapaAtual == 6 || PropostaElaboracaoCrud.idEtapaAtual == 2 || PropostaElaboracaoCrud.idEtapaAtual == 5"
                                      v-model="PropostaElaboracaoCrud.dsObservacao"></textarea>
                            <Field name="dsObservacao" label="Observação" type="hidden"
                                   v-model="PropostaElaboracaoCrud.dsObservacao" />
                            <ErrorMessage name="dsObservacao" class="form-error" v-show="showErrorMessage" />
                        </div>

                        <div class="mb-5 mt-3">
                            <label class="form-label">Corpo E-mail</label>
                            <textarea class="form-control shadow-v2" id="txt_dsCorpoEmail" rows="8"
                                      :disabled="PropostaElaboracaoCrud.idEtapaAtual == 6 || PropostaElaboracaoCrud.idEtapaAtual == 2 || PropostaElaboracaoCrud.idEtapaAtual == 5"
                                      v-model="PropostaElaboracaoCrud.dsCorpoEmail"></textarea>
                            <Field name="dsCorpoEmail" label="Corpo E-mail" type="hidden"
                                   v-model="PropostaElaboracaoCrud.dsCorpoEmail" />
                            <ErrorMessage name="dsCorpoEmail" class="form-error" v-show="showErrorMessage" />
                            <button type="button" class="btn btn-white-v3" style="float: right;border-radius: 0 0 5px 5px;"
                                    v-on:click="verExemploEmail"
                                    v-if="PropostaElaboracaoCrud.idEtapaAtual == 6 || PropostaElaboracaoCrud.idEtapaAtual == 2 || PropostaElaboracaoCrud.idEtapaAtual == 5"
                                    disabled>
                                Ver Exemplo
                            </button>
                            <button type="button" class="btn btn-white-v3" style="float: right;border-radius: 0 0 5px 5px;"
                                    v-on:click="verExemploEmail" v-else>
                                Ver Exemplo
                            </button>
                        </div>
                        <div class="mb-3 mt-3">
                            <div v-if="PropostaElaboracaoCrud.idEtapaAtual == 6 || PropostaElaboracaoCrud.idEtapaAtual == 2 || PropostaElaboracaoCrud.idEtapaAtual == 5"
                                 disabled>
                                <input-upload ref="inputuploadv2" :url-upload="urlPropostaAnexoUpload" :manualDisable="true"
                                              @on-save="salvarAnexo" :labelText="'Anexo da Proposta'" />
                            </div>
                            <div v-else>
                                <input-upload ref="inputuploadv2" :url-upload="urlPropostaAnexoUpload"
                                              :manualDisable="false" @on-save="salvarAnexo" :labelText="'Anexo da Proposta'" />
                            </div>
                        </div>
                        <div class="mb-3 mt-3" v-if="flTemAnexo == true">
                            <div class="row fundo-panel">
                                <div class="col">
                                    <Field name="dsNomeArquivo" label="E-mail Cópia" type="text"
                                           class="form-control shadow-v2" style="min-height: 40px" placeholder="Nome do anexo"
                                           v-model="dsNomeArquivo" :class="{ filled: dsNomeArquivo }" />
                                </div>
                                <div class="col" style="margin-left: -22px">
                                    <button type="button" class="btn btn-red" style="width: 100%" form="form"
                                            v-on:click="postAnexoProposta">
                                        Salvar Anexo
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-if="lstAnexos.length > 0" style="margin-top: 10px">

                            <ul v-if="PropostaElaboracaoCrud.idEtapaAtual == 6 || PropostaElaboracaoCrud.idEtapaAtual == 2 || PropostaElaboracaoCrud.idEtapaAtual == 5"
                                disabled>
                                <li class="list-group-item list-group-li shadow-v2 ps-3 mb-2"
                                    style="font-size: 14px;border-radius: 5px;" v-for="item in lstAnexos" :key="item.id">
                                    {{ item.nmAnexo }}
                                    <button type="button" class="btn btn-excluir"
                                            style="float: right; margin-left: 5px;position: relative;top: -2px;" disabled>
                                        <i class="fa fa-trash"></i>
                                    </button>
                                    <button type="button" class="btn btn-excluir"
                                            style="float: right;position: relative;top: -2px;" disabled>
                                        <i class="fas fa-cloud-download-alt"></i>
                                    </button>
                                </li>
                            </ul>
                            <ul v-else>
                                <li class="list-group-item list-group-li shadow-v2 ps-3 mb-2"
                                    style="font-size: 14px;border-radius: 5px;" v-for="item in lstAnexos" :key="item.id">
                                    {{ item.nmAnexo }}
                                    <button type="button" class="btn btn-excluir"
                                            style="float: right; margin-left: 5px;position: relative;top: -2px;"
                                            v-on:click="excluirAnexo(item.idPropostaAnexo)">
                                        <i class="fa fa-trash"></i>
                                    </button>
                                    <button type="button" class="btn btn-excluir"
                                            style="float: right;position: relative;top: -2px;"
                                            v-on:click="downloadAnexo(item.idPropostaAnexo)">
                                        <i class="fas fa-cloud-download-alt"></i>
                                    </button>
                                </li>
                            </ul>

                        </div>


                        <!-- DESCONTO -->
                        <div class="row mt-3">
                            <div class="row col-3">
                                <div v-if="PropostaElaboracaoCrud.idEtapaAtual == 6 || PropostaElaboracaoCrud.idEtapaAtual == 2 || PropostaElaboracaoCrud.idEtapaAtual == 5"
                                     disabled>
                                    <label class="form-control-checkbox">
                                        <input type="checkbox" disabled /> Tem Desconto
                                    </label>
                                </div>
                                <div v-else>
                                    <label class="form-control-checkbox" v-if="PropostaElaboracaoCrud.flTemDesconto == true">
                                        <input type="checkbox" @click="setarDesconto($event)" checked /> Tem Desconto
                                    </label>
                                    <label class="form-control-checkbox" v-else>
                                        <input type="checkbox" @click="setarDesconto($event)" /> Tem Desconto
                                    </label>
                                </div>

                            </div>
                            <div class="row"
                                 v-if="PropostaElaboracaoCrud.flTemDesconto == true && PropostaElaboracaoCrud.idEtapaAtual != 6 && PropostaElaboracaoCrud.idEtapaAtual != 2 && PropostaElaboracaoCrud.idEtapaAtual != 5">
                                <div class="col-6">
                                    <label for="exampleFormControlInput1" class="form-label col-12 text-center">
                                        Valor
                                        Desconto
                                    </label>
                                    <CurrencyInput :id="'vlDesconto'" v-bind:value="PropostaElaboracaoCrud.vlDesconto" v-model="PropostaElaboracaoCrud.vlDesconto" :options="{ currency: 'BRL', precision: 2 }" :class="{ filled: PropostaElaboracaoCrud.vlDesconto > 0 }" />
                                    <ErrorMessage name="vlDesconto" class="form-error" v-show="showErrorMessage" />
                                </div>

                            </div>
                        </div>
                    </div>
                   
                    <div class="row mt-3" v-if="PropostaElaboracaoCrud.idEtapaAtual == 3">
                        <div class="col">
                            <fieldset>
                                <legend class="text-center">Solicitação de Ajustes</legend>
                                <div class="linha-cinza"></div>
                                <p class="text-center" style="margin-top: -10px">{{ PropostaElaboracaoCrud.dsMovimentoAtual }}</p>
                            </fieldset>
                        </div>
                    </div>

                    <div class="row mt-3" v-if="PropostaElaboracaoCrud.idEtapaAtual == 6">
                        <div class="col">
                            <fieldset>
                                <legend class="text-center">Motivo do Fracasso</legend>
                                <div class="linha-cinza"></div>
                                <p class="text-center" style="margin-top: -10px">{{ PropostaElaboracaoCrud.dsMovimentoAtual }}</p>
                            </fieldset>
                        </div>
                    </div>

                </div>

            </Form>
        </template>

        <!-- FOOTER -->
        <template v-slot:footer>
            <div class="modal-footer">
                <div class="row col-12" style="margin-right: -50px;">
                    <div class="col-1">
                        <button type="button" class="btn btn-close-clean-v2 mt-2" style="bottom: 6px;"
                            data-bs-dismiss="modal" @click="fecharModal()">Fechar</button>
                    </div>
                    <div class="col-4 row d-flex" style="gap:10px;">
                        <div class="col-4" style="display: contents;">                                                        
                            <button type="button" class="btn btn-declaracao" v-if="PropostaCrud.nmRptPropostaCrud != null" @click="verProposta(PropostaElaboracaoCrud)"><i class="fas fa-eye"></i> Ver Proposta</button>
                        </div>
                        <div class="col-4"></div>  
                        <div class="col-4"></div>
                    </div>

                    <!-- OPCOES DA PROPOSTA FOOTER -->

                    <!-- SOLICITAR/ENVIAR/FRACASSAR/ATT -->
                    <div class="col-7 d-flex justify-content-end pe-4" v-if="PropostaElaboracaoCrud.idEtapaAtual == 1 || PropostaElaboracaoCrud.idEtapaAtual == 3">
                        <div class="col-12 row d-flex justify-content-end me-0" style="gap:10px;">
                            
                            <div class="col" style="display: contents;" v-if="verifica_regra_desconto(PropostaElaboracaoCrud.idTipoProposta)">
                                <button type="button" class="btn btn-declaracao green" v-on:click="solicitarAprovacao">
                                    <i class="fas fa-check"></i> Solicitar Aprovação
                                </button>
                            </div>

                            <div class="col" style="display: contents;" v-else>
                                <button type="button" class="btn btn-declaracao green" v-on:click="enviarProposta">
                                    <i class="fa fa-paper-plane"></i> Enviar
                                </button>
                            </div>

                            <div class="col" style="display: contents;">
                                <button type="button" class="btn btn-declaracao" v-on:click="fracassarProposta">
                                    <i class="fas fa-ban"></i> Fracassar
                                </button>
                            </div>

                            <div class="col" style="display: contents;">
                                <button type="submit" class="btn btn-red-v2" form="form" v-on:click="submitForm"
                                        style="max-height: 10px;">
                                    <i class="fas fa-save" style="margin-right: 10px;"></i>
                                    Alterar e Atualizar
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- AGUARDANDO AP -->
                    <div class="col-7" v-else-if="PropostaElaboracaoCrud.idEtapaAtual == 2">
                        <div class="col d-flex flex-row-reverse pe-4">
                            <span class="pt-1 text-warning" id="semRegistros"><strong>Proposta aguardando
                                    Aprovação</strong></span>
                        </div>
                    </div>

                    <!-- ENVIAR/AP -->
                    <div class="col-7 row" v-else-if="PropostaElaboracaoCrud.idEtapaAtual == 4">
                        <div class="col-6"></div>
                        <div class="col-6 row">
                            <div class="col pe-0 d-flex" style="justify-content:flex-end">
                                <button type="button" class="btn btn-declaracao green" @click="enviarProposta">
                                    <i class="fa fa-paper-plane"></i> Enviar
                                </button>
                                <span class="ps-4 pt-1 text-success" id="semRegistros"><strong>Proposta
                                        Aprovada</strong></span>
                            </div>
                        </div>
                    </div>

                    <!-- REENVIAR/FRACASSAR/PROPEVIADA -->
                    <div class="col-7 row" v-else-if="PropostaElaboracaoCrud.idEtapaAtual == 5">
                        <div class="col-6"></div>
                        <div class="col-6 row">
                            <div class="col pe-0 d-flex" style="justify-content:flex-end">
                                <button type="button" class="btn btn-declaracao green"
                                    style="padding-left: 12px;padding-right: 12px;" @click="reenviarProposta">
                                    <i class="fa fa-paper-plane"></i> Reenviar
                                </button>
                                <button type="button" class="btn btn-declaracao" style="margin-left: 10px"
                                    @click="fracassarProposta">
                                    <i class="fas fa-ban"></i> Fracassar
                                </button>
                                <span class="ps-4 pt-1 text-success" id="semRegistros"
                                    :style="customStatus"><strong>Proposta
                                        Enviada</strong></span>
                            </div>
                        </div>
                    </div>

                    <!-- FRACASSADA -->
                    <div class="col-7 row" v-else-if="PropostaElaboracaoCrud.idEtapaAtual == 6">
                        <span class="col d-flex flex-row-reverse pt-1 text-danger" id="semRegistros"><strong>Proposta
                                Fracassada</strong></span>
                    </div>

                    <!-- ACEITA PELO CLIENTE -->
                    <div class="col-7 d-flex" v-else-if="PropostaElaboracaoCrud.idEtapaAtual == 7">
                        <div class="col-8"></div>
                        <div class="col-4 pe-4">
                            <span class="col pt-1 d-flex text-success" style="flex-direction:row-reverse ;"
                                id="semRegistros"><strong>Proposta aceita pelo
                                    Cliente</strong></span>
                        </div>
                    </div>

                    <!-- NAO INICIADA -->
                    <div class="col-7 d-flex" v-else>
                        <div class="col-8"></div>
                        <div class="col-4 pe-4">
                            <span class="col d-flex pt-1 text-warning" style="flex-direction:row-reverse ;"
                                id="semRegistros"><strong>Proposta não  Iniciada</strong></span>
                        </div>
                    </div>
                </div>


            </div>

            <modal-warper target="ExemploEmailProposta" :show="isOpenModalEmailExemplo"
                @close="(isOpenModalEmailExemplo = false)">
                <ExemploEmailProposta :nmContatoCliente="nmContatoCliente" :dsCorpoEmail="dsCorpoEmail"
                    :show="isOpenModalEmailExemplo" />
            </modal-warper>

        </template>

    </Modal>
</template>

<script>

    import axios from 'axios';
    import VueNextSelect from 'vue-next-select'
    import 'vue-next-select/dist/index.min.css'
    import Modal from '@/components/App/Modal.vue'
    import InputUpload from '@/components/App/Input_Upload.vue'
    import CurrencyInput from '@/components/App/CurrencyInput.vue'
    import ModalWarper from '@/components/App/ModalWarper.vue'
    import ExemploEmailProposta from '@/views/Modais/Ocorrencia/Modais/ExemploEmailProposta.vue'
    import DateInput from "@/components/App/DateInput.vue";
    import CryptoJS from 'crypto-js';

    export default {
        name: 'Proposta_Crud',
        components: {
            Modal,
            'vue-select': VueNextSelect,
            InputUpload,
            CurrencyInput,
            ModalWarper,
            ExemploEmailProposta,
            DateInput
        },
        props: {
            idProposta: {
                type: Number,
                default: 0
            },
            idOcorrencia: {
                type: Number,
                default: 0
            },
            idModulo: {
                type: Number,
                default: 0
            },
            show: {
                type: Boolean,
                default: false
            },
            idInstituicao: {
                type: Number,
                default: 0
            },
            idEvento: {
                type: Number,
                default: 0
            },
            idPessoa: {
                type: Number,
                default: 0
            }
        },
        data() {
            return {
                PropostaElaboracaoCrud: {
                    idPropostaElaboracao: 0,
                    idProposta: 0,
                    idPlano: 0,
                    nrProposta: 0,
                    nrAno: 0,
                    dtGeracao: '',
                    dtValidade: '',
                    qtdLicencas: 0,
                    qtdUsuarios: 0,
                    qtdInscritos: 0,
                    nmCliente: '',
                    nmContatoCliente: '',
                    idPessoa: 0,
                    dsEmail: '',
                    dsEmailCopia: '',
                    nrDiasContrato: 0,
                    dsCorpoEmail: '',
                    vlDesconto: 0,
                    flIndice: '',
                    dsDataBaseIndice: '',
                    vlProposta: 0,
                    dsObservacao: '',
                    dtValidadeString: '',
                    dtGeracaoString: '',
                    idEtapaAtual: 0,
                    lstPropostaElaboracaoCortesia: [],
                    flIndiceCorrecao: false,
                    idContratoIndice: 0,
                    vlrContratoAtual: 0,
                    idTipoProposta: 0,
                    idInscricao: 0,
                    flTemDesconto: false,
                    flTemCortesia: false,
                    dsMovimentoAtual: '',
                    idMovimento: 0,
                    lstProdutosPlano: [],
                    nmRptPropostaCrud: '',
                    idModulo: 0
                },
                PropostaCrud: {
                    idProposta: 0,
                    idMovimentoAtual: 0,
                    idPessoa: 0,
                    idTipoProposta: 0,
                    idInstituicao: 0,
                    idAcompanhamentoContato: 0,
                    idContrato: 0,
                    idAcompanhamentoContatoRecuperacao: 0,
                    idInscricao: 0,
                    idEvento: 0,
                    idModulo: 0,
                    idContratoIndiceCorrecaoValor: 0,
                    idOcorrencia: 0,
                    vlrContratoAtual: '',
                    qtdUsuariosContratoAtual: 0,
                    qtdUtilizacoesContratoAtual: 0,
                    idPlanoContratoAtual: 0,
                    nmRptPropostaCrud: ''
                },

                pessoa_instituicao: [],
                pessoa_instituicao_selects: { idPessoa: 0 },


                vlrContratoAtual: 0,
                urlPropostaAnexoUpload: process.env.VUE_APP_ROOT_COMERCIAL_API + '/Proposta/PostUploadAnexoProposta',
                dsNomeArquivo: '',
                vlPropostaAtualizado: 0,
                showErrorMessage: false,

                PostFracassarProposta: {
                    idMovimento: 0,
                    idProposta: 0
                },

                isOpenModalEmailExemplo: false,
                nmContatoCliente: '',
                dsCorpoEmail: '',

                flTemAnexo: false,
                AnexoCrud: {
                    idPropostaAnexo: 0,
                    idProposta: 0,
                    nmAnexo: '',
                    urlAnexo: ''
                },
                lstAnexos: [],
                customHeight: '',
                customStatus: '',
                customWidthDate: '',
                evento: { vlInscricao: 0, vlInscricaoOnline: 0 }

            }
        },
        computed: {
        },
        methods: {
            verifica_regra_desconto(_idTipoProposta) {
                let $this = this;                

                if (_idTipoProposta == null) {
                    return false;
                }

                switch (_idTipoProposta.toString()) {
                    //Presencial
                    case '1':
                        var vlMedioPresencial = (this.PropostaElaboracaoCrud.vlProposta) / this.PropostaElaboracaoCrud.qtdInscritos;

                        var valor_desconto_maximo = (this.evento.vlInscricao - this.evento.vlDesconto);
                        valor_desconto_maximo = (this.evento.vlInscricao - valor_desconto_maximo);

                        if (vlMedioPresencial < valor_desconto_maximo) {
                            return true;
                        } else {
                            return false;
                        }
                    //OnLine
                    case '2':
                        var vlMedioOnLine = (this.PropostaElaboracaoCrud.vlProposta) / this.PropostaElaboracaoCrud.qtdInscritos;

                        var valor_desconto_maximo2 = (this.evento.vlInscricaoOnline - this.evento.vlDescontoOnline);
                        valor_desconto_maximo2 = (this.evento.vlInscricaoOnline - valor_desconto_maximo2);

                        if (vlMedioOnLine < valor_desconto_maximo2) {
                            return true;
                        } else {
                            return false;
                        }
                    default:
                        if (this.PropostaElaboracaoCrud.vlDesconto != null && this.PropostaElaboracaoCrud.vlDesconto > 0) {
                            return true;
                        } else {
                            return false;
                        }
                }
            },
            verProposta(proposta) {
                var data_pdf = { path: 'Comercial\\Propostas', name: proposta.nmRptPropostaCrud, database: 'NPComercialDB', listParam: 'idProposta', valueParam: proposta.idProposta };
                const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data_pdf), 'reports_gnp').toString();
                var hash = encodeURIComponent(encryptedData);
                window.open(window.location.origin + '/Visualizador_Reports?hash=' + hash, '_blank');
            },
            GetDadosEvento() {
                let $this = this;

                axios.get(
                    process.env.VUE_APP_ROOT_EVENTOS_API + "/Evento/GetDadosEvento?idEvento=" + $this.idEvento,
                    {
                        headers: $this.$api.getTokenEventos(),
                        params: "",
                    }
                ).then((response) => {
                    $this.evento = response.data.data;
                });
            },
            calcula_valor_proposta() {
                let $this = this;

                var total_proposta = 0;

                // CALCULA O VALOR DO PLANO MULTIPLACANDO PELO NUMERO DE LICENCAS E DIAS DO CONTRATO
                if (this.PropostaElaboracaoCrud.idTipoProposta == 1) {
                    total_proposta = ($this.evento.vlInscricao * $this.PropostaElaboracaoCrud.qtdInscritos);
                }
                else if (this.PropostaElaboracaoCrud.idTipoProposta == 2) {
                    total_proposta = ($this.evento.vlInscricaoOnline * $this.PropostaElaboracaoCrud.qtdInscritos);
                }
                // ATUALIZA O VALOR DA PROPSOTA COM O DESCONTO
                if ($this.PropostaElaboracaoCrud.flTemDesconto == true) {
                    total_proposta = (total_proposta - $this.PropostaElaboracaoCrud.vlDesconto);
                }
                setTimeout(() => {
                    $this.PropostaElaboracaoCrud.vlProposta = total_proposta;
                }, 400);
            },
            getPessoa() {
                let $this = this;

                if ($this.idPessoa > 0) {
                    axios.get(
                        process.env.VUE_APP_ROOT_COMERCIAL_API + "/Pessoa/GetPessoaById?id=" + $this.idPessoa,
                        {
                            headers: $this.$api.getTokenComercial(),
                            params: "",
                        }
                    ).then((response) => {
                        var array = [response.data.data];
                        $this.pessoa_instituicao = array;
                    });
                }
                else {
                    axios.get(
                        process.env.VUE_APP_ROOT_COMERCIAL_API + "/PessoaInstituicao/GetPessoasInstituicao?idInstituicao=" + $this.idInstituicao,
                        {
                            headers: $this.$api.getTokenComercial(),
                            params: "",
                        }
                    ).then((response) => {
                        $this.pessoa_instituicao = response.data.data;
                    });
                }
            },
            customizeHeight() {
                if (window.innerWidth <= 1400) {
                    this.customWidthDate = 'width:96%'

                    this.customHeight = 'max-height: calc(100vh - 22vh);'
                    this.customStatus = 'width: -webkit-fill-available;'
                } else if (window.innerWidth >= 3500) {
                    this.customHeight = 'max-height: calc(100vh - 4rem);'
                    this.customWidthDate = 'width:104.5%'

                }
                else {
                    this.customWidthDate = ''
                    this.customStatus = ''
                    this.customHeight = 'max-height: calc(100vh - 8rem);padding-top: 0 !important;'
                }
            },
            verExemploEmail() {
                this.isOpenModalEmailExemplo = true;
            },
            verDeclaracao(idProposta) {

            },
            getListaAnexos() {
                let $this = this;

                if ($this.PropostaElaboracaoCrud.idProposta != null && $this.PropostaElaboracaoCrud.idProposta > 0) {

                    axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Proposta/GetListaAnexos?' + '&idProposta=' + $this.PropostaElaboracaoCrud.idProposta, {
                        headers: $this.$api.getTokenComercial(),
                        params: ''
                    }).then(response => {

                        $this.lstAnexos = response.data.data.rows;

                    })
                        .catch(function (error) {
                            var msg = 'Ocorreu um erro inesperado';
                            if (error.response) {
                                if (error.response.data.erros != '') {
                                    msg = error.response.data.errors[0];
                                } else {
                                    msg = error.response.data.msg;
                                }
                            }
                            $this.$toast.show('alert', msg, true);
                        });

                }

            },
            excluirAnexo(idPropostaAnexo) {
                let $this = this;

                axios.delete(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Proposta/DeleteAnexo?idPropostaAnexo=' + idPropostaAnexo, {
                    headers: $this.$api.getTokenComercial()
                }).then(response => {

                    $this.getListaAnexos();

                }).catch(error => {
                    var msg = 'Ocorreu um erro inesperado';
                    if (error.response) {
                        if (error.response.data.erros != '') {
                            msg = error.response.data.errors[0];
                        } else {
                            msg = error.response.data.msg;
                        }
                    }

                    $this.$toast.show('alert', msg, true);
                });

            },
            salvarAnexo(url) {
                let $this = this;
                $this.flTemAnexo = true;
                $this.AnexoCrud.urlAnexo = url;
            },
            postAnexoProposta() {
                let $this = this;

                $this.AnexoCrud.idProposta = $this.PropostaElaboracaoCrud.idProposta;
                $this.AnexoCrud.nmAnexo = $this.dsNomeArquivo;

                if ($this.AnexoCrud.nmAnexo == null || $this.AnexoCrud.nmAnexo == '') {
                    $this.$toast.show('warning', 'Nome do anexo não pode estar em branco...', true);
                    return;
                }
                else {
                    axios.post(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Proposta/PostSalvarAnexo', $this.AnexoCrud, { headers: $this.$api.getTokenComercial() })
                        .then(function (response) {

                            $this.dsNomeArquivo = '';
                            $this.flTemAnexo = false;

                            $this.getListaAnexos();

                            $this.$refs.inputuploadv2.resetVariaveis();

                        })
                        .catch(function (error) {
                            var msg = 'Ocorreu um erro inesperado';
                            if (error.response) {
                                if (error.response.data.erros != '') {
                                    msg = error.response.data.errors[0];
                                } else {
                                    msg = error.response.data.msg;
                                }
                            }

                            $this.$toast.show('alert', msg, true);
                        });
                    $this.showErrorMessage = false;
                }


            },
            downloadAnexo(idPropostaAnexo) {
                let $this = this;

                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Proposta/GetDownloadAnexo?idPropostaAnexo=' + idPropostaAnexo, {
                    headers: $this.$api.getTokenComercial(),
                    params: ''
                }).then(response => {
                    window.open(response.data.data, "_blank");
                })

            },

            setarDesconto: function (event) {
                let $this = this;
                if (event.target.checked) {
                    $this.PropostaElaboracaoCrud.flTemDesconto = true;
                }
                else {
                    $this.PropostaElaboracaoCrud.flTemDesconto = false;
                    $this.PropostaElaboracaoCrud.vlDesconto = 0;
                }
            },

            formatNamePlano(result) {
                return result.nmPlano;
            },
            formatNamePessoa(result) {
                return result.nmPessoa + ' - (' + result.dsEmail + ')';
            },
            getProdutosPlano(_idPlano) {
                let $this = this;

                if (_idPlano != null && _idPlano > 0) {

                    axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/PropostaElaboracao/GetProdutosProposta?' + '&idPlano=' + _idPlano, {
                        headers: $this.$api.getTokenComercial(),
                        params: ''
                    }).then(response => {
                        $this.lstProdutosPlano = response.data.data.rows;
                        $this.PropostaElaboracaoCrud.lstProdutosPlano = $this.lstProdutosPlano;
                    });

                }
            },
            zerarInformacoes() {
                let $this = this;

                $this.PropostaElaboracaoCrud = {
                    idPropostaElaboracao: 0,
                    idProposta: 0,
                    idPlano: 0,
                    nrProposta: 0,
                    nrAno: 0,
                    dtGeracao: '',
                    dtValidade: '',
                    qtdLicencas: 0,
                    qtdUsuarios: 0,
                    qtdInscritos: 0,
                    nmCliente: '',
                    nmContatoCliente: '',
                    idPessoa: 0,
                    dsEmail: '',
                    dsEmailCopia: '',
                    nrDiasContrato: 0,
                    dsCorpoEmail: '',
                    vlDesconto: 0,
                    flIndice: '',
                    dsDataBaseIndice: '',
                    vlProposta: 0,
                    dsObservacao: '',
                    dtValidadeString: '',
                    dtGeracaoString: '',
                    idEtapaAtual: 0,
                    lstPropostaElaboracaoCortesia: [],
                    flIndiceCorrecao: false,
                    idContratoIndice: 0,
                    vlrContratoAtual: 0,
                    idTipoProposta: 0,
                    idInscricao: 0,
                    flTemDesconto: false,
                    flTemCortesia: false,
                    dsMovimentoAtual: '',
                    idMovimento: 0,
                    lstProdutosPlano: [],
                    nmRptPropostaCrud: '',
                    idModulo: 0
                };
                $this.pessoa_instituicao_selects = { idPessoa: 0 };
                $this.showErrorMessage = false;
                $this.flTemCortesia = false;
            },
            fecharModal() {
                this.$emit("reloadGrid");
                this.zerarInformacoes();
            },
            get() {
                let $this = this;
                $this.getPessoa();

                if ($this.idProposta == 0) {
                    $this.PropostaElaboracaoCrud = {
                        idPropostaElaboracao: 0,
                        idProposta: 0,
                        idPlano: 0,
                        nrProposta: 0,
                        nrAno: 0,
                        dtGeracao: '',
                        dtValidade: '',
                        qtdLicencas: 0,
                        qtdUsuarios: 0,
                        qtdInscritos: 0,
                        nmCliente: '',
                        nmContatoCliente: '',
                        idPessoa: 0,
                        dsEmail: '',
                        dsEmailCopia: '',
                        nrDiasContrato: 0,
                        dsCorpoEmail: '',
                        vlDesconto: 0,
                        flIndice: '',
                        dsDataBaseIndice: '',
                        vlProposta: 0,
                        dsObservacao: '',
                        dtValidadeString: '',
                        dtGeracaoString: '',
                        idEtapaAtual: 0,
                        lstPropostaElaboracaoCortesia: [],
                        flIndiceCorrecao: false,
                        idContratoIndice: 0,
                        vlrContratoAtual: 0,
                        idTipoProposta: 0,
                        idInscricao: 0,
                        flTemDesconto: false,
                        flTemCortesia: false,
                        dsMovimentoAtual: '',
                        idMovimento: 0,
                        lstProdutosPlano: [],
                        nmRptPropostaCrud: '',
                        idModulo: 0
                    };
                } else {
                    axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/PropostaElaboracao/GetByIdProposta?idProposta=' + $this.idProposta, {
                        headers: $this.$api.getTokenComercial(),
                        params: ''
                    }).then(response => {
                        $this.PropostaElaboracaoCrud = response.data.data;

                        setTimeout(() => {
                            $this.pessoa_instituicao_selects = $this.pessoa_instituicao.find(p => {
                                return p.idPessoa === $this.PropostaElaboracaoCrud.idPessoa;
                            });
                        }, 400);

                        $this.vlPropostaAtualizado = $this.PropostaElaboracaoCrud.vlProposta;
                        $this.nmContatoCliente = $this.PropostaElaboracaoCrud.nmContatoCliente;
                        $this.dsCorpoEmail = $this.PropostaElaboracaoCrud.dsCorpoEmail;



                        if ($this.PropostaElaboracaoCrud.vlDesconto > 0) {
                            $this.PropostaElaboracaoCrud.flTemDesconto = true;
                        }


                        $this.getListaAnexos();
                    });
                }
            },
            solicitarAprovacao() {
                let $this = this;

                $this.submitForm(true)
                    .then(validationResult => {
                        if (validationResult) {
                            $this.PropostaElaboracaoCrud.idMovimento = 2;
                            return $this.submitForm();
                        }
                    })
                    .then(submissionResult => {
                    })
                    .catch(error => {
                    });
            },

            enviarProposta() {
                let $this = this;

                $this.submitForm(true)
                    .then(validationResult => {
                        if (validationResult) {
                            $this.PropostaElaboracaoCrud.idMovimento = 5;
                            return $this.submitForm(); // Chama o submitForm sem parâmetros após a validação inicial
                        }
                    })
                    .then(submissionResult => {
                    })
                    .catch(error => {
                    });
            },
            reenviarProposta() {
                let $this = this;

                $this.enviarProposta();
            },
            fracassarProposta() {
                let $this = this;

                $this.PostFracassarProposta.idMovimento = 6;
                $this.PostFracassarProposta.idProposta = $this.PropostaElaboracaoCrud.idProposta;

                axios.post(process.env.VUE_APP_ROOT_COMERCIAL_API + '/PropostaElaboracao/PostFracassarPropostaTicket', $this.PostFracassarProposta, { headers: $this.$api.getTokenComercial() })
                    .then(function (response) {
                        var myModalEl = document.getElementById('Proposta_Crud');
                        var ModalNew = window.bootstrap.Modal.getInstance(myModalEl);

                        ModalNew.hide();

                        $this.$emit('reloadGrid');
                        $this.zerarInformacoes();
                    })
                    .catch(function (error) {
                        var msg = 'Ocorreu um erro inesperado';
                        if (error.response) {
                            if (error.response.data.erros != '') {
                                msg = error.response.data.errors[0];
                            } else {
                                msg = error.response.data.msg;
                            }
                        }

                        $this.$toast.show('alert', msg, true);
                    });
                $this.showErrorMessage = false;

            },
            submitForm(valida) {
                let $this = this;

                return new Promise((resolve, reject) => {
                    $this.$refs.ABC.validate()
                        .then(isValid => {
                            if (isValid.valid) {
                                axios.post(process.env.VUE_APP_ROOT_COMERCIAL_API + '/PropostaElaboracao/PostPropostaElaboracaoTicket', $this.PropostaElaboracaoCrud, { headers: $this.$api.getTokenComercial() })
                                    .then(function (response) {
                                        if (!valida) {
                                            var myModalEl = document.getElementById('Proposta_Crud');
                                            var ModalNew = window.bootstrap.Modal.getInstance(myModalEl);

                                            ModalNew.hide();

                                            $this.$emit('reloadGrid');
                                            $this.zerarInformacoes();

                                            resolve(true);
                                        } else {
                                            resolve(true);
                                        }
                                    })
                                    .catch(function (error) {
                                        var msg = 'Ocorreu um erro inesperado';
                                        if (error.response) {
                                            if (error.response.data.erros != '') {
                                                msg = error.response.data.errors[0];
                                            } else {
                                                msg = error.response.data.msg;
                                            }
                                        }

                                        $this.$toast.show('alert', msg, true);
                                        resolve(false);
                                    });
                                $this.showErrorMessage = false;
                            } else {
                                throw new Error('Por favor, preencha todos os campos obrigatórios');
                            }
                        })
                        .catch(error => {
                            var msg = 'Por favor, preencha todos os campos obrigatórios';
                            if (error.response) {
                                if (error.response.data.erros != '') {
                                    msg = error.response.data.errors[0];
                                } else {
                                    msg = error.response.data.msg;
                                }
                            }
                            $this.showErrorMessage = true;
                            $this.$toast.show('alert', msg, true);
                            resolve(false);
                        });
                });
            },

        },
        mounted() {

            this.customizeHeight();
            window.addEventListener('resize', this.customizeHeight);
        },
        updated() {
            this.customizeHeight();
        },
        watch: {
            show(new_value, old_value) {
                if (new_value) {
                    this.get();
                }
            },
            idProposta(new_value, old_value) {
                if (new_value) {
                    //this.get();
                }
            },
            pessoa_instituicao_selects(new_value, old_value) {
                if (new_value) {
                    this.PropostaElaboracaoCrud.idPessoa = new_value.idPessoa;
                    this.PropostaElaboracaoCrud.nmContatoCliente = new_value.nmPessoa;
                    this.PropostaElaboracaoCrud.dsEmail = new_value.dsEmail;
                }
            },
            idOcorrencia(n, o) { },
            idEvento(n, o) { this.GetDadosEvento(); },
            idModulo(newVal, oldVal) { },

            'PropostaElaboracaoCrud.qtdInscritos': function (n, o) {
                this.calcula_valor_proposta();
            },

            'PropostaElaboracaoCrud.flTemDesconto': function (n, o) {
                this.calcula_valor_proposta();
            },

            'PropostaElaboracaoCrud.vlDesconto': function (n, o) {
                this.calcula_valor_proposta();
            },
        },
    }

</script>

<style scoped lang="scss">
    .form-control-checkbox {
        font-family: system-ui, sans-serif;
        font-size: 14px;
        font-weight: bold;
        line-height: 1.1;
        display: grid;
        grid-template-columns: 1em auto;
        gap: 0.5em;

        > input {
            cursor: pointer;
        }

        input[type="checkbox"] {
            -webkit-appearance: none;
            appearance: none;
            background-color: #fff;
            margin: 0;
            font: inherit;
            color: currentColor;
            width: 1.18em;
            height: 1.16em;
            border: 0.15em solid #900;
            border-radius: 0.15em;
            transform: translateY(-0.075em);
            display: grid;
            place-content: center;
        }

        input[type="checkbox"]::before {
            content: "";
            width: 0.65em;
            height: 0.65em;
            transform: scale(0);
            transition: 120ms transform ease-in-out;
            box-shadow: inset 1em 1em #900;
            transform-origin: bottom left;
            clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
        }

        input[type="checkbox"]:checked::before {
            transform: scale(1);
        }
    }

    .fundo-panel {
        overflow-y: auto;
        overflow-x: hidden;
    }

    .btn-white-v3 {
        background: white;
        box-shadow: 0px 0px 4px 0px #00000040;
        min-height: 40px;
        padding: 0 35px 3px 35px;
        color: #9F3029;
        font-weight: 500;
        font-size: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #9F3029;
    }

    .btn-white-v3:hover {
        color: white;
        background: #9F3029 !important;
        border: 1px solid #9F3029 !important;
    }

    .btn-declaracao {
        box-sizing: border-box;
        width: max-content;
        height: 35px;
        background: #FFFFFF;
        box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.25);
        border-radius: 5px;
        padding: 0 20px 3px 20px;
        font-weight: 700;
        font-size: 12px;
        color: #9f3029;
        border: 1px solid #9F3029;

        &:hover {
            background: #9f3029;
            color: white;
        }

        &.green {
            background: #34A853;
            color: white;
            border: 1px solid #34A853;

            &:hover {
                color: #34A853;
                background: white;
                border: 1px solid #34A853;
            }
        }
    }

    .btn-excluir {
        box-sizing: border-box;
        height: 25px;
        background: #FFFFFF;
        border-radius: 5px;
        padding: 0 10px 5px 10px;
        font-weight: 700;
        font-size: 12px;
        color: #9F3029;

        &:hover {
            color: #9f3129b9;
        }
    }

    .semRegistros {
        color: #9f3029;
        padding: 7px 15px;
    }

    .list-group-item {
        position: relative;
        display: block;
        padding: 10px 15px;
        background-color: #fff;
        border: 1px solid #ddd;
    }

    .list-group {
        padding-left: 0;
        margin-bottom: 20px;
    }

    .list-group-li {
        font-size: 10px;
        padding: 10px 5px;
        height: auto;
        line-height: 20px;
    }
</style>